import { createMyPluginFactory } from '../plateFunctions';

const SHOW_DEBUG_OUTPUT = false;

/** If SHOW_DEBUG_OUTPUT=true prints out the document to the console */
export const createDebugPlugin = createMyPluginFactory({
  key: 'DEBUG',
  handlers: {
    onChange: () => (value) => {
      SHOW_DEBUG_OUTPUT &&
        process.env.NODE_ENV === 'development' &&
        // eslint-disable-next-line no-console
        console.dir(value);
    },
  },
});
